import React, { Component } from 'react';
import DigiSeal from '../common/digiSeal.component.jsx';

class Title extends Component {
    render(){
        return (
                <section className="content-header">
                    <h1>Mein <DigiSeal /> Konto</h1>
                </section>
        );
    }
}

export default Title